<template>
    <v-container fluid class="pa-0">
        <WorkspaceSettingsDialog
            v-if="canChangeWorkspace"
            :is-open="workspaceSettingsDialog"
            :workspace-id-data="workspaceId"
            :workspaces-data="workspaces"
            :production-processes="productionProcesses"
            :report-settings-data="reportSettings"
            @on-save="changeWorkspace"
            @on-abort="() => workspaceSettingsDialog = false"
        />
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-container class="pa-0">
                    <v-row justify="space-between" dense align="center">
                        <v-col>
                            <v-toolbar-title class="text-subtitle-1">
                                Stanowisko
                            </v-toolbar-title>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        v-if="canChangeWorkspace"
                                        fab
                                        x-small
                                        color="secondary"
                                        elevation="1"
                                        :loading="isLoading || loading"
                                        v-on="on"
                                        @click="showWorkspaceSettingsDialogHandler(false)"
                                    >
                                        <v-icon>
                                            mdi-printer-3d
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Zmiana stanowiska</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>

            <v-divider />

            <v-card-text class="py-8 text-center">
                <div class="text-h3 font-weight-bold black--text">
                    {{ workspaceName }}
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'WorkspaceSelector',
    components: {
        WorkspaceSettingsDialog: () => import('@/views/Reports/Reporting/WorkspaceSettingsDialog.vue'),
    },
    mixins: [
        tooltipDelay,
    ],
    props: {
        showWorkspaceSettingsDialog: {
            type: Boolean,
        },
        isLoading: {
            type: Boolean,
        },
        canChangeWorkspace: {
            type: Boolean,
        },
        currentWorkspace: {
            type: Object,
            default: () => ({})
        },
        reportSettings: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            loading: false,
            workspaceSettingsDialog: false,
        }
    },
    computed: {
        productionProcesses() {
            return this.$store.state.configurations.productProductionProcesses.productionProcesses
        },
        workspaces() {
            return this.$store.state.configurations.productionSites.productionSites
        },
        workspaceId() {
            return this.currentWorkspace ? this.currentWorkspace.id : null
        },
        workspaceName() {
            return this.currentWorkspace ? this.currentWorkspace.name : '-'
        }
    },
    watch: {
        showWorkspaceSettingsDialog(value) {
            if (value) {
                this.showWorkspaceSettingsDialogHandler()
            }
        }
    },
    mounted() {
        if (!this.productionProcesses) {
            this.$store.dispatch('configurations/getProductionProcesses')
        }
    },
    methods: {
        showWorkspaceSettingsDialogHandler() {
            this.loading = true

            this.$store.dispatch('configurations/getProductionSites', {query:'?type_id=2,3,4,5,7'})
                .then(() => {
                    this.workspaceSettingsDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        changeWorkspace(value) {
            this.$emit('change-workspace', value)
            this.workspaceSettingsDialog = false
        },
    }
}
</script>
